<template>
    <PriceComponent/>
    <router-view></router-view>
</template>

<script>
import PriceComponent from '@/components/price/PriceComponent.vue';
    export default {
        name:"PriceView",
        components:{
            PriceComponent
        }
    }
</script>